<script setup lang="ts">
useSeoMeta({
  title: 'News',
});

const category = ref<number>();
const sort = ref<(typeof sortOptions)[number]['value']>('-date_published');
const search = ref<string>();

const sortOptions = [
  {
    label: 'Newest',
    value: '-date_published',
  },
  {
    label: 'Oldest',
    value: 'date_published',
  },
] as const;

const { data: data1, pending: pending1 } = await useNewsCategories();
const categoryOptions = computed(() =>
  unref(data1).map((x) => ({ label: x.name, value: x.id })),
);
const {
  data: items,
  error,
  pending: pending2,
} = await useNewsList({
  category,
  sort,
  search,
});

const loading = useLoadingIndicator();
watch([pending1, pending2], ([pending1, pending2]) => {
  loading.isLoading.value = pending1 || pending2;
});

const event = useRequestEvent();
if (event) {
  if (process.env['NODE_ENV'] === 'production') {
    event.node.res.setHeader(
      'Cache-Control',
      'public, max-age=180, stale-while-revalidate',
    );
  }
}
</script>

<template>
  <NuxtLayout>
    <div class="container">
      <h1 class="heading">CMLA News</h1>
      <NewsFilterBar
        :categoryOptions="categoryOptions"
        :sortOptions="sortOptions"
        v-model:category="category"
        v-model:sort="sort"
        v-model:search="search"
      >
        <template #prepend> </template>
      </NewsFilterBar>
      <template v-if="items?.length">
        <div class="list">
          <NewsListItem v-for="item in items" :key="item.id" :item="item" />
        </div>
      </template>
      <template v-else-if="error">
        <div class="text-danger text-center">{{ error.message }}</div>
      </template>
      <template v-else>
        <Empty>No news is good news.</Empty>
      </template>
    </div>
  </NuxtLayout>
</template>

<style scoped lang="scss">
.heading {
  margin-top: 90px;
  margin-bottom: 40px;
}
</style>
